export default (strOrArray) => {
    if (!Array.isArray(strOrArray) && ('string' !== typeof strOrArray && 'number' !== typeof strOrArray)) {
        throw new Error(`Invalid input.`)
    }

    const arr = typeof strOrArray === 'string' ? `${strOrArray}`.split(/\s*,\s*|\s+|\n+/) : strOrArray

    return arr.map(str => `${str}`.trim()).filter(Boolean)
}